export default {
      id: "map-marker-alt-usage",
      viewBox: "0 0 18 24",
      url: __webpack_public_path__ + "svg/sprite.svg#map-marker-alt",
      toString: function () {
        return this.url;
      }
    }